import {
  useBulkSendComment,
  useDeleteComment,
  useDeleteLike,
  useGetComments,
  useGetMentionableUsers,
  useGetMineUnread,
  useGetMineUnreadAsOperator,
  useGetReadUnreadByEngagement,
  useLike,
  useMarkAsRead,
  useMarkAsUnread,
  useReplyComment,
  useSendComment,
} from './useComments'
import { useGetCorrectnessBreakdown } from './useGetCorrectnessBreakdown'
import { useGetCorrectnessBreakdownV3 } from './useGetCorrectnessBreakdownV3'
import { useGetPendingEngagements } from './useGetPendingEngagements'
import { useGetPlatformVolumeV3 } from './useGetPlatformVolumeV3'
import { useGetProgramBreakdown } from './useGetProgramBreakdown'
import { useGetVolume } from './useGetVolume'
import {
  useGetNotificationFilters,
  useGetNotifications,
  useMarkAllNotificationsAsRead,
  useMarkNotificationAsRead,
} from './useNotification'

export const platform = {
  getVolume: useGetVolume,
  getCorrectnessBreakdown: useGetCorrectnessBreakdown,
  getVolumeV3: useGetPlatformVolumeV3,
  getCorrectnessBreakdownV3: useGetCorrectnessBreakdownV3,
  getProgramBreakdown: useGetProgramBreakdown,
  getPendingEngagements: useGetPendingEngagements,
  sendComment: useSendComment,
  replyComment: useReplyComment,
  deleteComment: useDeleteComment,
  markAsRead: useMarkAsRead,
  markAsUnread: useMarkAsUnread,
  getComments: useGetComments,
  getMentionableUsers: useGetMentionableUsers,
  likeComment: useLike,
  deleteLikeComment: useDeleteLike,
  mineUnreadComments: useGetMineUnread,
  getNotifications: useGetNotifications,
  readUnreadCommentsByEngagement: useGetReadUnreadByEngagement,
  mineUnreadOperatorComments: useGetMineUnreadAsOperator,
  getNotificationFilters: useGetNotificationFilters,
  markNotificationAsRead: useMarkNotificationAsRead,
  markAllNotificationAsRead: useMarkAllNotificationsAsRead,
  bulkSendComment: useBulkSendComment,
}
